import { useObserver } from 'mobx-react';
import { Route, withRouter } from "react-router-dom";
import { useEffect } from 'react';
import vm from './UnableAlimtalkSendModalVm';
import st from './UnableAlimtalkSendModal.module.scss';
import CheckBox from '@standby/common-ui/components/atoms/Input/CheckBox/CheckBox';
import MessageHint from '@commonComponents/MessageHint/MessageHint';

function UnableAlimtalkSendModal(props) {
    return useObserver(() => (
        <div className={st.modalContent}>
            <div className={st.sendList}>
                <div className={st.title}>발송방식</div>
                <div>
                    {vm.personInCharges.map((personInCharge, index) => (
                        <ul className={st.checkboxList} key={index}>
                            {personInCharge.phoneNumber && 
                                <li><CheckBox checked={vm.sendChecked(personInCharge.id, 'sendAlimtalk')} onChange={(e) => vm.sendList(e, personInCharge.id, 'sendAlimtalk')}>{personInCharge?.name ? `(${personInCharge?.name}) ` : ''}알림톡 {personInCharge.phoneNumber}</CheckBox></li>
                            }
                        </ul>
                    ))}
                </div>
            </div>
            <div className={st.btnWrap}>
                <button type='button' disabled={!vm.sendActive} className={st.mainBtn} onClick={() => vm.send(props.customerId)}><span>안내 보내기</span></button>
            </div>
            <MessageHint text="알림톡 미리보기" style={{marginTop:'4px'}}>
                <img src='/images/unableAlimtalkPreview.svg'/>
            </MessageHint>
        </div>
    ));
}
export default UnableAlimtalkSendModal;